import { clsx } from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

export function Divider({ className, ...rest }: HTMLAttributes<HTMLHRElement>) {
  return <hr {...rest} className={clsx('border-t border-hairline', className)} />;
}

export function Stat({ label, value, sub }: { label: string; value: ReactNode; sub?: ReactNode }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="field-label">{label}</span>
      <span className="text-feature-heading font-display text-ink">{value}</span>
      {sub && <span className="text-caption text-muted-slate">{sub}</span>}
    </div>
  );
}

export function Toast({ kind = 'info', children }: { kind?: 'info' | 'error' | 'success'; children: ReactNode }) {
  const color = kind === 'error' ? 'border-error-red text-error-red' : kind === 'success' ? 'border-deep-enterprise-green text-deep-enterprise-green' : 'border-hairline text-ink';
  return (
    <div role="status" className={clsx('rounded-md border bg-canvas-white px-4 py-3 text-body shadow-soft', color)}>
      {children}
    </div>
  );
}
